import React from 'react';
import { Eye } from 'lucide-react';
import styles from './PreviewPanel.module.css';

export interface PreviewPanelProps {
  previewHtml: string | undefined;
  previewSubject: string | undefined;
  isLoading: boolean;
  templateLoading: boolean;
  isError?: boolean;
}

const PreviewPanel: React.FC<PreviewPanelProps> = ({ previewHtml, previewSubject, isLoading, templateLoading, isError }) => {
  return (
    <aside className={styles.previewPanel} data-test-id="preview-panel">
      <div className={styles.previewHeader}>
        <Eye size={18} />
        <h2>Preview</h2>
        {isLoading && <span className={styles.previewLoading}>Updating...</span>}
      </div>
      <div className={styles.previewContent}>
        {previewHtml && previewSubject !== undefined && (
          <div className={styles.previewSubject} data-test-id="preview-subject">
            <span className={styles.previewSubjectLabel}>Subject:</span>
            <span className={styles.previewSubjectValue}>{previewSubject}</span>
          </div>
        )}
        {previewHtml && (
          <iframe
            srcDoc={previewHtml}
            title="Email Preview"
            sandbox="allow-same-origin"
            data-test-id="preview-iframe"
          />
        )}
        {!previewHtml && templateLoading && (
          <div className={styles.previewLoadingState}>Loading preview...</div>
        )}
        {!previewHtml && !templateLoading && (
          <div className={styles.previewEmpty}>
            <p>{isError ? 'Preview unavailable' : 'Preview will appear here'}</p>
          </div>
        )}
      </div>
    </aside>
  );
};

export default PreviewPanel;
